import { createAction, props } from "@ngrx/store"
import { CustomerDto, CustomerTypeDto, ServiceTypeDto } from "./customers.dtos"

export const fetchServiceTypes = createAction(
    '[Customers Module] fetch service types'
)

export const fetchServiceTypesFailed = createAction(
    '[Customers Module] STATUS: fetch service types failed'
)

export const fetchServiceTypesSuccess = createAction(
    '[Customers Module] STATUS: fetch service types success',
    props<{serviceTypes}>()
)


export const createServiceType = createAction(
    '[Customers Module] create service type',
    props<{serviceTypeDto: ServiceTypeDto}>()
)

export const createServiceTypeFailed = createAction(
    '[Customers Module] STATUS: create service type failed'
)

export const createServiceTypeSuccess = createAction(
    '[Customers Module] STATUS: create service type success'
)

export const updateServiceType = createAction(
    '[Customers Module] update service type',
    props<{serviceTypeDto: ServiceTypeDto, serviceTypeId: string}>()
)

export const updateServiceTypeFailed = createAction(
    '[Customers Module] STATUS: update service type failed'
)

export const updateServiceTypeSuccess = createAction(
    '[Customers Module] STATUS: update service type success'
)

export const deleteServiceType = createAction(
    '[Customers Module] delete service type',
    props<{serviceTypeId: string}>()
)

export const deleteServiceTypeFailed = createAction(
    '[Customers Module] STATUS: delete service type failed'
)

export const deleteServiceTypeSuccess = createAction(
    '[Customers Module] STATUS: delete service type success'
)


export const fetchCustomerTypes = createAction(
    '[Customers Module] fetch customer types'
)

export const fetchCustomerTypesFailed = createAction(
    '[Customers Module] STATUS: fetch customer types failed'
)

export const fetchCustomerTypesSuccess = createAction(
    '[Customers Module] STATUS: fetch customer types success',
    props<{customerTypes}>()
)

export const createCustomerType = createAction(
    '[Customers Module] create customer type',
    props<{customerTypeDto: CustomerTypeDto}>()
)

export const createCustomerTypeFailed = createAction(
    '[Customers Module] STATUS: create customer type failed'
)

export const createCustomerTypeSuccess = createAction(
    '[Customers Module] STATUS: create customer type success'
)

export const updateCustomerType = createAction(
    '[Customers Module] update customer type',
    props<{customerTypeDto: CustomerTypeDto, customerTypeId: string}>()
)

export const updateCustomerTypeFailed = createAction(
    '[Customers Module] STATUS: update customer type failed'
)

export const updateCustomerTypeSuccess = createAction(
    '[Customers Module] STATUS: update customer type success'
)

export const deleteCustomerType = createAction(
    '[Customers Module] delete customer type',
    props<{customerTypeId: string}>()
)

export const deleteCustomerTypeFailed = createAction(
    '[Customers Module] STATUS: delete customer type failed'
)

export const deleteCustomerTypeSuccess = createAction(
    '[Customers Module] STATUS: delete customer type success'
)


export const fetchCustomers = createAction(
    '[Customers Module] fetch customers',
    props<{serviceTypeId: string}>()
)

export const fetchCustomersFailed = createAction(
    '[Customers Module] STATUS: fetch customers failed'
)

export const fetchCustomersSuccess = createAction(
    '[Customers Module] STATUS: fetch customers success',
    props<{customers}>()
)

export const createCustomerSingle = createAction(
    '[Customers Module] create customer single',
    props<{customerDto: CustomerDto, customerTypeId: string}>()
)

export const createCustomerSingleFailed = createAction(
    '[Customers Module] STATUS: create customer single failed'
)

export const createCustomerSingleSuccess = createAction(
    '[Customers Module] STATUS: create customer single success'
)

export const createCustomerBulk = createAction(
    '[Customers Module] create customer bulk',
    props<{customerDto: CustomerDto[], customerTypeId: string}>()
)

export const createCustomerBulkFailed = createAction(
    '[Customers Module] STATUS: create customer bulk failed'
)

export const createCustomerBulkSuccess = createAction(
    '[Customers Module] STATUS: create customer bulk success'
)